import clsx from 'clsx';
import styles from './input-label.module.css';
import { ReactNode } from 'react';

export type RequiredLabel = Exclude<ReactNode, undefined>;

interface InputLabelPropsAsLabel {
  label: RequiredLabel;
  subLabel?: ReactNode;
  required?: boolean;
  as?: 'label';
  htmlFor: string;
  readersOnly?: boolean;
}

interface InputLabelPropsAsLegend {
  label: RequiredLabel;
  subLabel?: ReactNode;
  className?: string;
  required?: boolean;
  as: 'legend';
  readersOnly?: boolean;
}

type InputLabelProps = InputLabelPropsAsLabel | InputLabelPropsAsLegend;

export function InputLabel({
  label,
  subLabel,
  required,
  readersOnly,
  ...restProps
}: InputLabelProps) {
  if (!restProps.as || restProps.as === 'label') {
    return (
      <label
        className={clsx(styles.label, readersOnly && styles.readerOnly)}
        htmlFor={restProps.htmlFor}
      >
        <span>
          {label}
          {required && <span>*</span>}
        </span>

        {subLabel &&
          (typeof subLabel === 'string' ? (
            <p className={clsx('body-3', styles.subLabel)}>{subLabel}</p>
          ) : (
            subLabel
          ))}
      </label>
    );
  }
  return (
    <legend className={clsx(styles.label, readersOnly && styles.readerOnly)}>
      <span>
        {label}
        {required && <span>*</span>}
      </span>
      {subLabel &&
        (typeof subLabel === 'string' ? (
          <p className={clsx('body-3', styles.subLabel)}>{subLabel}</p>
        ) : (
          subLabel
        ))}
    </legend>
  );
}
